import { ReactNode } from 'react';

export interface SummaryProps {
  title: string;
  subtitle?: string | ReactNode;
  children: ReactNode;
  summaryComponent: ReactNode;
}
export function Summary({ title, subtitle, children, summaryComponent }: SummaryProps) {
  return (
    <details className="bg-neutral-50 px-5 py-2 shadow-md">
      <summary className="grid grid-cols-[auto_max-content] grid-rows-2">
        <div className="flex items-center gap-2 col-start-1 row-start-1">
          <span className="text-title font-medium">{title}</span>
          <span className="opacity-50">{subtitle}</span>
        </div>
        <div className="flex gap-2 items-center col-start-1 row-start-2">{summaryComponent}</div>
        <i className="hover:cursor-pointer ri-arrow-down-s-line chevron col-start-2 row-start-1 row-span-2 self-center" />
      </summary>
      {children}
    </details>
  );
}
